module.exports = __webpack_public_path__ + "static/media/LaunchpadFooter.81f980cc.jpg";